import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterBar = ({ onFilterChange, activeFilters }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const filterOptions = {
    clientType: [
      { value: 'all', label: 'All Clients', icon: 'Users' },
      { value: 'commercial', label: 'Commercial', icon: 'Building2' },
      { value: 'residential', label: 'Residential', icon: 'Home' }
    ],
    serviceType: [
      { value: 'all', label: 'All Services', icon: 'Wrench' },
      { value: 'plumbing', label: 'Plumbing', icon: 'Droplet' },
      { value: 'electrical', label: 'Electrical', icon: 'Zap' }
    ],
    complexity: [
      { value: 'all', label: 'All Projects', icon: 'Layers' },
      { value: 'emergency', label: 'Emergency', icon: 'AlertCircle' },
      { value: 'standard', label: 'Standard', icon: 'CheckCircle' },
      { value: 'complex', label: 'Complex', icon: 'Settings' }
    ]
  };

  const handleFilterClick = (category, value) => {
    onFilterChange(category, value);
  };

  const clearAllFilters = () => {
    onFilterChange('reset');
  };

  const hasActiveFilters = Object.values(activeFilters)?.some(value => value !== 'all');

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 mb-6 md:mb-8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-headline font-semibold text-foreground text-lg md:text-xl flex items-center gap-2">
          <Icon name="Filter" size={24} />
          Filter Stories
        </h3>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="lg:hidden text-primary hover:text-primary/80 transition-colors"
          aria-label={isExpanded ? 'Collapse filters' : 'Expand filters'}
        >
          <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={24} />
        </button>
      </div>
      <div className={`space-y-4 md:space-y-6 ${isExpanded ? 'block' : 'hidden lg:block'}`}>
        <div>
          <p className="text-sm font-medium text-muted-foreground mb-3 font-body">Client Type</p>
          <div className="flex flex-wrap gap-2">
            {filterOptions?.clientType?.map((option) => (
              <Button
                key={option?.value}
                variant={activeFilters?.clientType === option?.value ? 'default' : 'outline'}
                size="sm"
                iconName={option?.icon}
                iconPosition="left"
                onClick={() => handleFilterClick('clientType', option?.value)}
              >
                {option?.label}
              </Button>
            ))}
          </div>
        </div>

        <div>
          <p className="text-sm font-medium text-muted-foreground mb-3 font-body">Service Type</p>
          <div className="flex flex-wrap gap-2">
            {filterOptions?.serviceType?.map((option) => (
              <Button
                key={option?.value}
                variant={activeFilters?.serviceType === option?.value ? 'default' : 'outline'}
                size="sm"
                iconName={option?.icon}
                iconPosition="left"
                onClick={() => handleFilterClick('serviceType', option?.value)}
              >
                {option?.label}
              </Button>
            ))}
          </div>
        </div>

        <div>
          <p className="text-sm font-medium text-muted-foreground mb-3 font-body">Project Complexity</p>
          <div className="flex flex-wrap gap-2">
            {filterOptions?.complexity?.map((option) => (
              <Button
                key={option?.value}
                variant={activeFilters?.complexity === option?.value ? 'default' : 'outline'}
                size="sm"
                iconName={option?.icon}
                iconPosition="left"
                onClick={() => handleFilterClick('complexity', option?.value)}
              >
                {option?.label}
              </Button>
            ))}
          </div>
        </div>

        {hasActiveFilters && (
          <div className="pt-4 border-t border-border">
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              iconPosition="left"
              onClick={clearAllFilters}
            >
              Clear All Filters
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterBar;